import { FormSectionHeader } from "@/components"
import { Card, CardContent } from "@/components/ui"
import { cn } from "@/lib/utils"
import comingSoonIllustration from "@/assets/comingSoonIllustration.png"

const CommunitySnapshot = ({snapshotCards}: {snapshotCards: any}) => {
  return (
    <Card className="shadow-none rounded-none border-0 border-t-1">
      <CardContent>
        <FormSectionHeader className="text-[18px] font-[500] text-gray-900">
          Community Snapshot
        </FormSectionHeader>
        <div className="grid grid-cols-1 overflow-hidden rounded-lg md:grid-cols-2 xl:grid-cols-3 gap-5">
          {snapshotCards?.map((data: any) => (
            <Card
              className={cn(
                "rounded-md p-0 border",
                data?.onClick && "cursor-pointer",
                data?.className,
                data?.comingSoon
              )}
              key={data?.title}
              onClick={data?.onClick}
            >
              <CardContent
                className={cn(
                  "flex flex-row items-center gap-3 p-3",
                  data?.comingSoon && "h-full min-h-[106px] justify-center"
                )}
              >
                {data?.comingSoon ? (
                  <img
                    src={comingSoonIllustration}
                    alt="Coming soon"
                    className="h-[82px] w-[100px] shrink-0 object-contain"
                  />
                ) : (
                  <div
                    className={cn(
                      "flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
                      data?.iconClassName
                    )}
                  >
                    <data.icon className="h-5 w-5" />
                  </div>
                )}
                <div
                  className={cn(
                    "flex min-w-0 flex-col",
                    data?.comingSoon && "text-left"
                  )}
                >
                  <span
                    className={cn(
                      "text-[22px] font-[700] leading-6",
                      data?.comingSoon && "whitespace-nowrap text-[18px] leading-5 text-primary",
                      data?.textClassName
                    )}
                  >
                    {data?.comingSoon ? data?.title : data?.value}
                  </span>
                  {!data?.comingSoon && (
                    <span className="text-[14px] font-normal text-gray-800">
                      {data?.title}
                    </span>
                  )}

                  {!data?.comingSoon && data?.subText ? (
                    <div className="flex flex-col text-[12px] font-normal text-gray-500">
                      {data?.subText}
                    </div>
                  ) : !data?.comingSoon && data?.subValue ? (
                    <span className="text-[12px] font-normal text-gray-500">
                      {data?.subValue}
                    </span>
                  ) : data?.comingSoon ? (
                    <span className="text-[12px] font-normal text-gray-500">
                      We’re working on something exciting. Stay tuned!
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}

export default CommunitySnapshot;
